module.exports = __webpack_public_path__ + "static/media/resume-calling.a67bd17b.png";